import { Component, inject } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { ApiService } from '../../../../services/api.service';

@Component({
  selector: 'app-attiva-abbonamento-backoffice',
  templateUrl: './attiva-abbonamento-backoffice.component.html',
  styleUrls: ['./attiva-abbonamento-backoffice.component.css']
})
export class AttivaAbbonamentoBackofficeComponent {

  constructor(private apiService: ApiService) { }

  loading: boolean = false;  

  readonly #modal = inject(NzModalRef);
  readonly nzModalData = inject(NZ_MODAL_DATA);

  onAttiva() {
    this.loading = true;

    // Attivo l'abbonamento
    this.apiService.attivaAbbonamento(this.nzModalData.stripe_sub!, this.nzModalData.id_abbonamento!).subscribe({
      next: (data) => this.apiService.setAbbonamenti(),
      error: (err) => {
        this.loading = false;
        this.apiService.error(err.error.message);
      }, complete: () => {
        this.loading = false;
        this.#modal.destroy();
      }
    })
  }

  onClose() {
    this.#modal.destroy();
  }

}
